import { render, staticRenderFns } from "./Ready.vue?vue&type=template&id=754860b6&"
import script from "./Ready.vue?vue&type=script&lang=js&"
export * from "./Ready.vue?vue&type=script&lang=js&"
import style0 from "./Ready.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports